module.exports = __webpack_public_path__ + "statics/img/apply.c0b1d228.png";